import { useState, useCallback } from 'react';
import DiagnosisService from '../Services/DiagnosisService';
import { type CreateDiagnosisParams } from '../../Types/schema-helpers';

interface UseDiagnosisReturn {
  submitDiagnosis: (payload: CreateDiagnosisParams) => Promise<any>;
  isLoading: boolean;
  error: Error | null;
}

export const useDiagnosis = (): UseDiagnosisReturn => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const submitDiagnosis = useCallback(async (payload: CreateDiagnosisParams) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await DiagnosisService.createDiagnosisEntry(payload);
      setIsLoading(false);
      return response;
    } catch (err) {
      setIsLoading(false);
      setError(err as Error);
      throw err;
    }
  }, []);

  return { submitDiagnosis, isLoading, error };
};